import { RemoveProductsFromWishlistDocument } from '../../queries/RemoveProductsFromWishlist.gql'
import { useMutation } from './useMutation'

const useRemoveProductsFromWishlist = () => {
  const [mutation] = useMutation(RemoveProductsFromWishlistDocument)

  const removeProductsFromWishlist = (wishlistItemsId: string) =>
    mutation({
      variables: {
        wishlistId: '0',
        wishlistItemsIds: [wishlistItemsId],
      },
    })

  return removeProductsFromWishlist
}

export default useRemoveProductsFromWishlist
